import React, { useState, useEffect } from 'react';
import "../style/home.css";
import "../style/product_category.css";
import "../style/widget.css";
import { Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Button from '@mui/material/Button';
import axiosInstance from "../axios_helper/axiosInstance";
import Skeleton from '@mui/material/Skeleton';
import EditIcon from '@mui/icons-material/Edit';

export default function Shop1Categories() {
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState(''); // Single input state for both add/edit
  const [loading, setLoading] = useState(true);
  const [editingCategory, setEditingCategory] = useState(null); // Track if a category is being edited

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = () => {
    setLoading(true);
    axiosInstance.get('/categories/?shop=1')
      .then(response => {
        const categoriesWithCounts = response.data.map(category => ({
          ...category,
          itemCount: 0,
          totalNetWeight: 0,
        }));
        setCategories(categoriesWithCounts);

        categoriesWithCounts.forEach(category => {
          axiosInstance.get(`/stock-items/?category=${category.name}`)
            .then(response => {
              const totalNetWeight = response.data.reduce((total, item) => total + parseFloat(item.nw || 0), 0);
              setCategories(prevCategories => prevCategories.map(cat =>
                cat.name === category.name
                  ? { ...cat, itemCount: response.data.length, totalNetWeight }
                  : cat
              ));
            })
            .catch(error => {
              console.error('Error fetching stock items:', error);
            });
        });
      })
      .catch(error => {
        console.error('Error fetching categories:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (editingCategory) {
      // If editing, update the category
      axiosInstance.put(`/categories/${editingCategory.name}/`, { name: categoryName, shop: 1 })
        .then(response => {
          fetchCategories(); // Refresh category list after update
          setEditingCategory(null); // Exit edit mode
          setCategoryName(''); // Reset the input field
        })
        .catch(error => {
          console.error('Error updating category:', error);
        });
    } else {
      // If not editing, add a new category
      axiosInstance.post('/categories/', { name: categoryName, shop: 1 })
        .then(response => {
          fetchCategories();
          setCategoryName(''); // Clear the input field after adding
        })
        .catch(error => {
          console.error('Error adding category:', error);
        });
    }
  };

  const handleEditCategory = (category) => {
    setEditingCategory(category); // Set the category to be edited
    setCategoryName(category.name); // Pre-fill the input with the existing category name
  };

  const handleCancelEdit = () => {
    setEditingCategory(null); // Exit edit mode
    setCategoryName(''); // Clear the input field
  };

  return (
    <div className="home">
      <Sidebar />
      <div className="home-container">
        <Header />
        <div className="category-container">
          <div className="name_button">
            <div className="heading">
              <h2>MJ Shop Categories</h2>
            </div>
            <form className='cate_input_bttn' onSubmit={handleFormSubmit}>
              <label className='label_input'>
                <span>Category Name </span>
                <input
                  type="text"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  required
                  maxLength="12"
                />
              </label>
              <Button
                className='add_cate_bttn'
                type="submit"
                variant="contained"
                style={{ backgroundColor: '#6439ff', paddingLeft: '10px' }}
              >
                {editingCategory ? 'Update' : 'Add Category'}
              </Button>
              {editingCategory && (
                <Button
                  className='add_cate_bttn'
                  onClick={handleCancelEdit}
                  variant="contained"
                  style={{ backgroundColor: '#6439ff', paddingLeft: '10px', marginLeft: '5px' }}
                >
                  Cancel
                </Button>
              )}
            </form>
          </div>
          <div className="category-widgets">
            {loading ? (
              Array.from(new Array(categories.length || 1)).map((_, index) => (
                <div className="widget_box" key={index}>
                  <Skeleton variant="text" width={100} height={30} />
                  <Skeleton variant="text" width={50} height={30} />
                  <Skeleton variant="rectangular" width={60} height={60} />
                </div>
              ))
            ) : (
              categories.map(category => (
                <div className="widget_box" key={category.id}>
                  <div className="left">
                    <span className="title">{category.name}</span>
                    <span className="number">{category.itemCount}</span>
                    <Link to={`/categories/${category.name}`}>
                      <span className="link">See all</span>
                    </Link>
                  </div>
                  <div className="right">
                    <Button onClick={() => handleEditCategory(category)}>
                      <EditIcon style={{ fontSize: 30, color: "#7451f8" }} />
                    </Button>
                    <span className="n_wt">
                      N.wt: <br />
                      {category.totalNetWeight
                        ? (parseFloat(category.totalNetWeight).toFixed(3))  // Ensures 3 decimal places
                        : "0.000"}g
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
